import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { API_ENDPOINTS, getApiUrl } from '../config/api';
import styles from '../styles/SchoolAdmin.module.css';
import { getBrutalistStyles } from '../styles/brutalist';
import BrutalistNavigation from '../components/BrutalistNavigation';

export default function SchoolAdmin() {
  const { token } = useAuth();
  const { isDarkMode } = useTheme();
  const brutalistStyles = getBrutalistStyles(isDarkMode);
  const [students, setStudents] = useState([]);
  const [tokenBalance, setTokenBalance] = useState(0);
  const [newStudent, setNewStudent] = useState({ name: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    // Load token balance
    fetch(getApiUrl('/school/balance'), {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => setTokenBalance(data.available_tokens))
      .catch(err => setError('Error loading token balance'));
  }, [token]);

  const createToken = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!newStudent.name.trim()) {
      setError('Por favor, introduce el nombre del alumno');
      return;
    }

    try {
      const response = await fetch(getApiUrl(API_ENDPOINTS.createToken), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          studentName: newStudent.name,
          schoolId: 'admin-school-001' // Using our admin school ID
        })
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(`Token creado: ${data.token}`);
        setNewStudent({ name: '' });
        // Refresh token balance
        const balanceRes = await fetch(getApiUrl('/school/balance'), {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const balanceData = await balanceRes.json();
        setTokenBalance(balanceData.available_tokens);
      } else {
        setError(data.message || 'Error al crear el token');
      }
    } catch (err) {
      setError('Error al crear el token');
    }
  };

  return (
    <>
      <BrutalistNavigation />
      <div className={styles.container} style={{
        marginTop: '4rem',
        '@media (max-width: 768px)': {
          marginTop: '6rem'
        }
      }}>
        <h1 style={brutalistStyles.brutalistTitle}>
          PANEL DE ADMINISTRACIÓN
        </h1>
        
        <div className={styles.stats} style={{
          border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
          boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
          padding: '1.5rem',
          marginBottom: '2rem'
        }}>
          <div className={styles.statCard}>
            <h3 style={brutalistStyles.brutalistLabel}>TOKENS DISPONIBLES</h3>
            <p className={styles.tokenBalance} style={{
              fontSize: '2rem',
              fontWeight: 'bold'
            }}>{tokenBalance}</p>
          </div>
        </div>

        <div className={styles.createToken} style={{
          border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
          boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
          padding: '1.5rem'
        }}>
          <h2 style={brutalistStyles.brutalistTitle}>CREAR TOKEN PARA ALUMNO</h2>
          <form onSubmit={createToken} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label htmlFor="studentName" style={brutalistStyles.brutalistLabel}>
                NOMBRE DEL ALUMNO
              </label>
              <input
                type="text"
                id="studentName"
                value={newStudent.name}
                onChange={(e) => setNewStudent({ name: e.target.value })}
                placeholder="Nombre del alumno"
                style={brutalistStyles.brutalistInput}
              />
            </div>

            <button 
              type="submit" 
              style={brutalistStyles.brutalistButton}
            >
              Crear Token
            </button>
          </form>

          {error && <p style={brutalistStyles.brutalistError}>{error}</p>}
          {success && (
            <div style={{
              marginTop: '1rem',
              padding: '1rem',
              backgroundColor: '#4CAF50',
              color: '#fff',
              border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
              boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`
            }}>
              <p style={{ marginBottom: '1rem' }}>{success}</p>
              <button 
                onClick={() => navigator.clipboard.writeText(success.split(': ')[1])}
                style={{
                  ...brutalistStyles.brutalistButton,
                  backgroundColor: '#fff',
                  color: '#000'
                }}
              >
                Copiar Token
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}